import { render } from "./Pager.vue?vue&type=template&id=81ee47cc&scoped=true"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"

import "./Pager.vue?vue&type=style&index=0&id=81ee47cc&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ee47cc"]])

export default __exports__